import 'bootstrap/js/dist/button'
// import Carousel from 'bootstrap/js/dist/carousel'
import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import { handleFloatingBtn, addActiveClassToMenuItem, addNavScrollingClasses, addScrollOffset } from './microsite-scripts'

document.querySelector('.hero-arrow-down')?.addEventListener('click', function () {
  const top = document.querySelector('.hero-block, .hero-carousel-wrapper').scrollHeight - (document.querySelector('nav').scrollHeight * 2)
  window.scrollTo({ top: top, left: 0, behavior: 'smooth' })
});

const header = document.querySelector('header')
const navCollapse = document.getElementById('micrositeNav')

const handleClickOutsideNav = (e) => {
  if (!e.target.closest('.navbar-collapse') && !e.target.classList.contains('navbar-toggler')) {
    const navCollapseInstance = Collapse.getInstance(navCollapse)
    navCollapseInstance.hide()
    header.classList.remove('nav-open')
    document.body.classList.remove('page-overlay')
  } 
}

navCollapse.addEventListener('show.bs.collapse', event => {
  header.classList.add('nav-open')
  document.body.classList.add('page-overlay')
  document.addEventListener('click', handleClickOutsideNav)
})

navCollapse.addEventListener('hide.bs.collapse', event => {
  header.classList.remove('nav-open')
  document.body.classList.remove('page-overlay')
  document.removeEventListener('click', handleClickOutsideNav)
})

let lastScrollPos = window.scrollY
const navbar = document.querySelector('header .navbar')

window.addEventListener('scroll', () => {
  addNavScrollingClasses(navbar, lastScrollPos)
  lastScrollPos = window.scrollY;
  addActiveClassToMenuItem()
  handleFloatingBtn()
})

if (document.querySelector('.hero-block .floating-btn')) {
  window.addEventListener('resize', handleFloatingBtn, true)
  addScrollOffset()
}

handleFloatingBtn()
addNavScrollingClasses(navbar, lastScrollPos)
addActiveClassToMenuItem()
handleFloatingBtn()
addScrollOffset()